<template>
<div>
    <div class="contianer">
        <p class="title">投诉类型</p>
        <div class="sub-title">
            <span v-for="(item,index) in reason" :key="index">
                <span v-if="index !== 0">></span><span>{{item}}</span>
            </span>
        </div>
        <div class="box1">
            <p class="box1-title">
                投诉描述
            </p>
            <van-field v-model="content" type="textarea" placeholder="请输入投诉描述…" />
        </div>
        <div class="box2">
            <createCompnents
            :cmpt="itemsList[0]"
            :key="itemsList[0].componentName+'-'+0"
            :extra="{parentIndex:0}">
            </createCompnents>
        </div>
        <!-- <div class="box2">
            <div class="box2-title">
                <span style="color:#F12525">*</span> 证据图片
            </div>
            <van-uploader v-model="fileList"  preview-size="45px" max-count="5" accept="img" :after-read="afterRead"  style="margin-left:16px"/>
        </div> -->
        <p class="tip mt-18">特别提醒：</p>
        <p class="tip">1、您投诉的内容将会由八度公司的管理员进行处理；</p>
        <p class="tip">2、请不要恶意投诉；</p>
        <p class="tip">3、收到您投诉后，会尽快按照相关法律法规的规定独立判断并进行处理。</p>
        <van-button type="info" class="submit-btn" @click="show = true">确认投诉</van-button>
        <van-popup v-model="show" style="border-radius: 11px;width:346px;top:75%;">
            <div class="aa-title">确认投诉后，将无法撤回投诉。请谨慎操作。</div>
            <div class="aa" @click="submit">确认投诉</div>
            <div class="aa" style="color:#242934" @click="show = false">再考虑下</div>
        </van-popup>
    </div>
</div>
</template>

<script>
import { Notify } from 'vant';
import head from '@/mixins/head';
import componnetInitValue from '@/mixins/component';
import componentHybird from '@/mixins/component-hybird';
import createCompnents from '@/views/approve/createCompnents';
export default {
    components: { createCompnents },
    mixins: [ head, componnetInitValue, componentHybird ],
    data() {
        return {
            title: '投诉个人',
            show: false,
            reason: [],
            content: '',
            // fileList: [],
            complaintClassification: '',
            groupName: '',
            itemsList: [
                {
                    componentName: 'PhotoField',
                    title: '证据图片',
                    value: [],
                    id: 'PhotoField-CDFKE11E',
                    inTableField: false,
                    model: 'CDFKE11E',
                    props: {
                        edit: false,
                        hide: false,
                        id: 'PhotoField-CDFKE11E',
                        label: '图片',
                        multiple: false,
                        required: true,
                        watermark: false
                    }
                }
            ]
        };
    },
    created() {
        this.title = this.$route.params.type === 0 ? '投诉个人' : '群投诉';
        this.complaintClassification = this.$route.params.type;
        this.reason = JSON.parse(this.$route.params.reason);
        this.groupName = this.$route.params.name;
        console.log(this.reason);
    },
    methods: {
        submit() {
            let complaintAttachDTOList = [];
            if (this.itemsList[0].length) {
                complaintAttachDTOList = this.itemsList[0].value.map(item => item.fileId);
            }
            if (!this.content) return Notify({ type: 'warning', message: '请填写投诉描述' });
            Notify({ type: 'success', message: '投诉成功，等待后台审核' });
            let params = {
                content: this.content,
                complaintAttachDTOList,
                complaintClassification: this.complaintClassification, // 个人：0；群：1
                complaintType: this.reason[0],
                complaintTypeInfo: this.reason[1] || '',
                protestantProfileId: +this.$route.params.bi
            };
            if (this.complaintClassification == 1) {
                params.complaintGroupName = this.groupName;
                params.respondentGroupId = this.$route.params.id;
                params.respondentProfileId = -2;
            } else {
                params.respondentProfileId = +this.$route.params.id;
            }
            this.$httpAxios
            .post('/bdsaas/ajax/account/protestant.do', params, {
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                transformResponse: [function (data) {
                    return data;
                }]
            })
            .then(res => {
                console.log('投诉结果', res);
            })
            .finally(() => {
                this.show = false;
            });
        }
        // afterRead(event) {
        //     console.log(event);
        //     let forms = new FormData();
        //     forms.append('fileData', event.file);
        //     this.$httpAxios
        //     .post('/bdsaas/ajax/website/websiteForm/uploadImage2.do', forms)
        //     .then(res => {
        //         console.log('上传文件', res);
        //     });
        // },
        // dataURLtoFile(dataurl, filename) {
        //     var arr = dataurl.split(',');
        //     var mime = arr[0].match(/:(.*?);/)[1];
        //     var bstr = atob(arr[1]);
        //     var n = bstr.length;
        //     var u8arr = new Uint8Array(n);
        //     while (n--) {
        //         u8arr[n] = bstr.charCodeAt(n);
        //     }
        //     return new File([u8arr], filename, { type: mime });
        // }
    }
};
</script>

<style lang="scss" scoped>
.van-cell{
    padding: 0;
}
.ml-10{
    margin-left: 10px;
}
.contianer{
    background-color: #F5F7FB;
    padding: 36px 14px 0 14px;
    width: 100%;
    height: 100%;
}
.mt-18{
    margin-top: 18px;
}
.title{
    height: 13px;
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #242934;
    line-height: 13px;
    text-align: left;
    margin-bottom: 11px;
}
.sub-title{
    height: 13px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #242934;
    line-height: 13px;
    text-align: left;
    margin-bottom: 31px;
}
.box1{
    height: 171px;
    background: #FFFFFF;
    border-radius: 11px;
    margin-bottom: 9px;
    padding: 14px 16px;
    .box1-title{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #242934;
        line-height: 14px;
        text-align: left;
        margin-bottom: 37px;
        &::before{
            content: '*';
            color: #F12525;
        }
    }
}
.box2{
    height: 133px;
    background: #FFFFFF;
    border-radius: 11px;
    margin-bottom: 18px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    /deep/.approve-photo-title.approve-photo--required{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #242934;
        line-height: 14px;
        text-align: left;
        &::before{
            position: initial;
            color: #F12525;
        }
    }
    .box2-title{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #242934;
        line-height: 14px;
        text-align: left;
        padding: 14px 16px;
        border-bottom: 1px solid #EDF1F6;
        margin-bottom: 22px;
    }
}
.tip{
    margin: 0 7px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9CA6B9;
    line-height: 16px;
    text-align: left;
}
.submit-btn{
    width: calc(100% - 44px);
    height: 43px;
    background: #0056FF;
    border-radius: 7px;
    margin: 137px 22px 36px 22px;
    border-color: #0056FF;
}
.aa-title{
    height: 44px;
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #9CA6B9;
    line-height: 44px;
    border-bottom: 1px solid #EDF1F6;
}
.aa{
    height: 58px;
    line-height: 58px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #0056FF;
    cursor: pointer;
}
</style>
